import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-loader',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * TODO
   */
  public typeSg = ngCore.input<
    'header' | 'tabs' | 'widget' | 'page' | 'table' | 'typing' | 'default'
  >('default', {
    alias: 'type',
  })

  /** Message to display under the loader */
  public messageSg = ngCore.input<string | undefined>(undefined, {
    alias: 'message',
  })
}
